<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Fecha de Pago</th>
                            <th>Hora de Pago</th>
                            <th class="text-right">Monto Pagado</th>
                            <th style="width: 60%">Observaciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in payments" :key="item.id">
                            <td>{{ item.payment_date | moment("DD/MM/YYYY") }}</td>
                            <td>{{ item.payment_date | moment("hh:mm a") }}</td>
                            <td class="text-right">{{ item.amount_payment | currency('S/') }}</td>
                            <td>{{ item.observations }}</td>
                        </tr>                        
                    </tbody>

                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'DebtDetail',
    props: ['payments'],
    data() {
        return {
            detail: []
        }
    }
}
</script>

<style scoped>
.item-number{
    width: 150px !important;
    min-width: 150px !important;
}

.foot-purchase{
    border-bottom: 0px !important;
}
</style>